// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileLensProfile_container__dVbq9","shareIconWrapper":"MobileLensProfile_shareIconWrapper__Ppxtt"};